"use client";

/**
 * PULSE Retrieval Variant Store
 *
 * A module-level store remembers the variant from the most recent job-search
 * API response so it can be attached as `pulse_variant` to AUD_JOB_* events.
 */

// Module-level store: variant reported by the most recent search response
// ("pulse" | "control" | "pulse_fallback"), undefined until a response is seen.
let lastSeenPulseVariant: string | undefined;

/**
 * Remember the variant from the most recent job-search API response
 * (`metadata.variant`). No-op when the response carries no variant.
 */
export function setLastSeenPulseVariant(variant?: string): void {
  if (variant) {
    lastSeenPulseVariant = variant;
  }
}

/**
 * Variant from the most recent job-search API response, or undefined if no
 * search response has been seen yet.
 */
export function getLastSeenPulseVariant(): string | undefined {
  return lastSeenPulseVariant;
}

